<div class="flex flex-col relative px-2 pt-5 pb-3">
  <button type="button" class="absolute right-[10px] top-[10px] flex items-center justify-center" (click)="matDialogRef.close(false)">
    <mat-icon svgIcon="close" class="!w-full !h-auto max-w-[14px] max-h-[14px] text-[#022D35]/40"></mat-icon>
  </button>
  <div class="text-[18px] text-center text-[#022D35] font-medium leading-[1.4]">
    Would you like to do general <br> AML report for wallet?
  </div>
  <div class="flex items-center text-center justify-center mt-2">
    <span class="text-[#50AF95]">
      {{ amlReportPrice() | number:('1.2-2') }}
    </span>
    <mat-icon svgIcon="tether" class="!w-full !h-auto max-w-[10px] max-h-[10px] text-[#50AF95] mx-1"></mat-icon>
    <span>cost of one time report</span>
  </div>
  <div class="flex gap-[10px] mt-3">
    <button type="button" mat-dialog-close class="text-[#90A2A5] text-[18px] flex flex-col items-center font-medium
     justify-center px-2 basis-1/2 min-h-[44px] border border-solid border-[#90A2A5] transition-all duration-500 ease-in-out
     hover:bg-[#90A2A5] focus:bg-[#90A2A5] hover:text-white focus:text-white
     rounded-[4px] leading-[1]"
    >
      Cancel
    </button>
    <button 
    [ngClass]="{'opacity-50 pointer-events-none': loadingCheckWallet()}"
    (click)="checkWallet()" type="button" class="text-white bg-[#50AF95] text-[18px] flex flex-col items-center font-medium
     justify-center px-2 basis-1/2 min-h-[44px] border border-solid border-[#50AF95] transition-all duration-500 ease-in-out
     hover:bg-[#2B9D7D] focus:bg-[#2B9D7D] hover:text-white focus:text-white
     rounded-[4px] leading-[1]"
    >
      Yes, verify
    </button>
  </div>
</div>
